import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';

//compnents
import BWAccordion from 'components/shared/BWAccordion/index';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormInput from 'components/shared/BWFormControl/FormInput';

import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormDebouneSelect from 'components/shared/BWFormControl/FormDebouneSelect';
import FormRangePicker from 'components/shared/BWFormControl/FormDateRange';
import FormDatePicker from 'components/shared/BWFormControl/FormDate';
import { useFormContext } from 'react-hook-form';
import { mapDataOptions4Select, mapDataOptions4SelectCustom } from 'utils/helpers';
import { withPortalScope } from 'utils/portalScope';
import { getOutputTypeOpts } from 'services/output-type.service';
import {
  areaByOutputTypeOpts,
  getBusinessOfAreaOpts,
  getPriceMasterData,
  getStoreOpts,
  readDetialOuputType,
} from 'pages/Prices/helpers/call-api';
import { showToast } from 'utils/helpers';
import { getErrorMessage } from 'utils/index';
import OutputTypeTable from './OutputTypeTable';
import FormNumber from 'components/shared/BWFormControl/FormNumber';

import { checkProductType } from '../contain/contain';
import { allArea, allBusiness, mapArrayRemoveKey } from './mathPrices';
import dayjs from 'dayjs';
import { formatPrice } from 'utils/index';
import { InputNumber, Segmented } from 'antd';
import { formatWarrantyNumber, parseWarrantyNumber } from 'pages/WarrantyManagement/warrantyNumber';
import {
  OUTPUT_TYPE_SELECT_ALL_VALUE,
  getSelectedOutputTypeOptions,
  normalizeOutputTypeSelection,
  resolveOutputTypeSelection,
} from './outputTypeSelection';
import './style.custom.scss';

const disabledDate = (current) => {
  // Can not select days before today and today
  return current && current < dayjs().startOf('day');
};

const emptyMasterData = {
  output_type_details: {},
  areas_by_output_type: {},
  businesses_by_area: {},
};

const MARKUP_MODE_PERCENT = 'percent';
const MARKUP_MODE_AMOUNT = 'amount';

const getMasterValue = (source = {}, key) => source?.[key] || source?.[String(key)] || source?.[Number(key)];

const uniqueByKey = (items = [], key) => {
  const result = [];
  const seen = new Set();
  items.forEach((item) => {
    const value = item?.[key];
    if (!value || seen.has(value)) return;
    seen.add(value);
    result.push(item);
  });
  return result;
};

const normalizeMoney = (value) => {
  if (value === null || value === undefined || value === '') return 0;
  const normalizedValue = typeof value === 'string' ? value.replace(/[, ]/g, '') : value;
  const numberValue = Number(normalizedValue);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

const formatMoneyInput = (value) => {
  if (value === null || value === undefined || value === '') return '';

  const numericValue = `${value}`.replace(/[^\d.-]/g, '');
  const [integerValue, decimalValue] = numericValue.split('.');
  const formattedInteger = integerValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  return decimalValue !== undefined ? `${formattedInteger}.${decimalValue}` : formattedInteger;
};

const parseMoneyInput = (value) => `${value || ''}`.replace(/[^\d.-]/g, '');

const getReferenceCostPrice = (item = {}) =>
  normalizeMoney(
    item?.reference_cost_price ||
      item?.cost_basic_imei_code ||
      item?.price_cost_avg ||
      item?.total_price_cost ||
      item?.cost_price,
  );

const PricesInfor = ({
  title,
  disabled,
  priceId,
  paramHidden,
  priceVatLabel = 'Giá bán — đã gồm VAT (đ)',
  costReferenceOverride,
  costReferenceTitle = 'Giá vốn tham chiếu',
  costReferenceSourceFallback = 'Theo dữ liệu kho hiện có',
  hideManyOutput = false,
  enableMarkupAmount = false,
  initializeAllScopes = false,
  noExpiry = false,
  uniformOutputPrice = false,
  autoApprove = false,
  vietnameseNumbers = false,
}) => {
  const methods = useFormContext();
  const displayMoney = value => vietnameseNumbers ? formatWarrantyNumber(value, 4) : formatPrice(value, false, ',');
  const moneyFormatter = vietnameseNumbers ? (value, info) => info?.userTyping ? info.input : formatWarrantyNumber(value, 4) : formatMoneyInput;
  const moneyParser = vietnameseNumbers ? value => parseWarrantyNumber(value) ?? '' : parseMoneyInput;
  const watchedAreas = methods.watch('areas');
  const watchedBusinesses = methods.watch('businesses');
  const watchedStores = methods.watch('stores');
  const watchedProductList = methods.watch('product_list');
  const watchedModelAttributeList = methods.watch('model_attribute_list');
  const watchedOutputTypeIds = methods.watch('output_type_ids');
  const priceVat = methods.watch('price_vat') ?? 0;
  const basePrice = methods.watch('base_price') ?? 0;
  const isManyOutputs = methods.watch('is_many_outputs');
  const selectedAreas = useMemo(() => (Array.isArray(watchedAreas) ? watchedAreas : []), [watchedAreas]);
  const selectedBusinesses = useMemo(
    () => (Array.isArray(watchedBusinesses) ? watchedBusinesses : []),
    [watchedBusinesses],
  );
  const selectedStores = useMemo(() => (Array.isArray(watchedStores) ? watchedStores : []), [watchedStores]);
  const selectedOutputTypeIds = useMemo(
    () => normalizeOutputTypeSelection(watchedOutputTypeIds),
    [watchedOutputTypeIds],
  );

  const [outputTypeOpts, setOutputTypeOpts] = useState([]);
  const [areaOpts, setAreaOpts] = useState([]);
  const [areaOptsManyOutType, setAreaOptsManyOutType] = useState([]);
  const [businessOpts, setBusinessOpts] = useState([]);
  const [outputTypeDetail, setOutputTypeDetail] = useState(undefined);
  const [masterData, setMasterData] = useState(emptyMasterData);
  const [markupPercent, setMarkupPercent] = useState(null);
  const [markupAmount, setMarkupAmount] = useState(null);
  const [markupMode, setMarkupMode] = useState(MARKUP_MODE_PERCENT);
  const initializedAllScopesRef = useRef(false);
  const vatValue = outputTypeDetail?.vat_value ? outputTypeDetail.vat_value * 1 : 0;
  const realAreaCount = areaOpts.filter((item) => item?.value !== allArea.value).length;
  const realBusinessCount = businessOpts.filter((item) => item?.value !== allBusiness.value).length;
  const isAllAreasSelected = Boolean(realAreaCount && selectedAreas.length >= realAreaCount);
  const isAllBusinessesSelected = Boolean(realBusinessCount && selectedBusinesses.length >= realBusinessCount);
  const selectedBusinessIds = useMemo(
    () => selectedBusinesses.map((item) => item?.value || item?.business_id).filter(Boolean).map((item) => String(item)),
    [selectedBusinesses],
  );
  const selectedPricingItems = useMemo(() => {
    const source = paramHidden === checkProductType['3'] ? watchedModelAttributeList : watchedProductList;
    return Object.values(source || {});
  }, [paramHidden, watchedModelAttributeList, watchedProductList]);
  const outputTypeSelectOptions = useMemo(
    () => [
      {
        value: OUTPUT_TYPE_SELECT_ALL_VALUE,
        label: 'Tất cả hình thức xuất',
      },
      ...outputTypeOpts,
    ],
    [outputTypeOpts],
  );

  const costReference = useMemo(() => {
    if (costReferenceOverride) {
      return costReferenceOverride;
    }

    if (!selectedPricingItems.length) {
      return {
        label: 'Chưa chọn sản phẩm',
        canCalculate: false,
        price: 0,
      };
    }

    const pricingItemsWithCost = selectedPricingItems
      .map((item) => ({
        item,
        price: getReferenceCostPrice(item),
      }))
      .filter(({ price }) => Number.isFinite(price) && price > 0);
    const prices = pricingItemsWithCost.map(({ price }) => price);
    const missingCostCount = selectedPricingItems.length - pricingItemsWithCost.length;
    const uniquePrices = [...new Set(prices.map((value) => Math.round(value)))];

    if (!uniquePrices.length) {
      return {
        label: 'Chưa có giá vốn',
        canCalculate: false,
        price: 0,
      };
    }

    if (missingCostCount > 0) {
      return {
        label: 'Thiếu giá vốn',
        canCalculate: false,
        price: 0,
        source: `${pricingItemsWithCost.length}/${selectedPricingItems.length} sản phẩm có giá vốn`,
      };
    }

    if (uniquePrices.length > 1) {
      return {
        label: 'Nhiều giá vốn',
        canCalculate: false,
        price: 0,
        source: `${uniquePrices.length} mức giá vốn khác nhau`,
      };
    }

    const itemWithCost = selectedPricingItems.find((item) => Math.round(getReferenceCostPrice(item)) === uniquePrices[0]);

    return {
      label: formatPrice(uniquePrices[0], true, ','),
      canCalculate: true,
      price: uniquePrices[0],
      source: itemWithCost?.reference_cost_source || 'Giá vốn tham chiếu',
    };
  }, [costReferenceOverride, selectedPricingItems]);

  const getInit = useCallback(async () => {
    try {
      const priceMasterData = await getPriceMasterData(withPortalScope({ is_active: 1 }));
      const nextMasterData = {
        ...emptyMasterData,
        ...(priceMasterData || {}),
      };

      setMasterData(nextMasterData);
      setOutputTypeOpts(mapDataOptions4Select(nextMasterData.output_types));
    } catch (error) {
      const _outputTypeOpts = await getOutputTypeOpts(withPortalScope({ is_active: 1 }));

      setMasterData(emptyMasterData);
      setOutputTypeOpts(mapDataOptions4Select(_outputTypeOpts));
      showToast.error(getErrorMessage(error));
    }
  }, []);

  useEffect(() => {
    // Load danh sách loại yêu cầu
    getInit();
  }, []);

  const handleChangeOutputType = async (value, { rebuildManyOutput = true } = {}) => {
    methods.setValue('output_type_id', value);
    if (!priceId) {
      methods.setValue('areas', []);
    }

    const areas = await getAreaByOutputTypeOpts(value);

    let _outputTypeDetail = getMasterValue(masterData.output_type_details, value);
    if (_outputTypeDetail) {
      _outputTypeDetail = structuredClone(_outputTypeDetail);
    }
    if (!_outputTypeDetail) {
      _outputTypeDetail = await readDetialOuputType(value);
    }

    if (_outputTypeDetail && !Array.isArray(_outputTypeDetail.area_id)) {
      _outputTypeDetail.area_id = areas || [];
    }

    setOutputTypeDetail(_outputTypeDetail);
    methods.setValue('outputTypeDetail', _outputTypeDetail);

    if (uniformOutputPrice && Number(methods.watch('price_vat') || 0) > 0) {
      const currentPriceVat = Number(methods.watch('price_vat'));
      const currentVatValue = Number(_outputTypeDetail?.vat_value || 0);
      const currentBasePrice = currentVatValue
        ? Math.round(currentPriceVat / ((100 + currentVatValue) / 100))
        : currentPriceVat;
      methods.setValue('base_price', currentBasePrice);
      methods.setValue('change_price', currentPriceVat);
    }

    // await handleChangeBasePrices(methods.watch('base_price'));

    if (_outputTypeDetail && _outputTypeDetail?.reviews.length) {
      let reviews = _outputTypeDetail?.reviews.map((_reviews) => {
        let review_detail = priceId
          ? methods
            .watch('review_list')
            .find((_review) => _review?.price_review_level_id == _reviews?.price_review_level_id)
          : {};
        return {
          ..._reviews,
          is_auto_reviewed: autoApprove ? 1 : _reviews?.is_auto_reviewed,
          review_user: !priceId && _reviews?.users && _reviews?.users.length > 0 ? _reviews?.users[0].user_name : null,
          ...review_detail,
        };
      });
      // set lại giá trị review cho user lấy user đầu tiên

      methods.setValue('review_list', reviews);
    }

    if (rebuildManyOutput && methods.watch('is_many_outputs')) {
      await handelChangeManyOutput(true, selectedOutputTypeIds);
    }
  };

  const getAreaByOutputTypeOpts = useCallback(
    async (output_type_id) => {
      // Lấy danh sách khu vực
      let cloneAllArea = structuredClone(allArea);
      let _areaOpts = getMasterValue(masterData.areas_by_output_type, output_type_id);
      if (!_areaOpts) {
        _areaOpts = await areaByOutputTypeOpts({ output_type_id: output_type_id });
      }
      const dataCompare = mapDataOptions4SelectCustom(_areaOpts, 'area_id', 'area_name');
      const checkValue = methods.watch('is_many_outputs');
      const dataAreaReturn = checkIsManyOutType(checkValue, areaOptsManyOutType, dataCompare);
      if (dataAreaReturn) {
        dataAreaReturn.unshift(cloneAllArea);
      }
      setAreaOpts(dataAreaReturn);
      return dataCompare;
    },
    [masterData, areaOptsManyOutType],
  );

  const checkIsManyOutType = (value, listCompare, listChange) => {
    let listPushArray = [];
    let cloneListCompare = structuredClone(listCompare);
    let cloneListChange = structuredClone(listChange);
    if (value) {
      if (cloneListCompare && cloneListCompare?.length) {
        cloneListCompare?.map((val) => {
          if (val?.area_id) {
            listPushArray.push(val?.area_id);
          }
        });
      }
      cloneListChange.filter((val) => listPushArray.includes(val?.area_id));
    }
    return cloneListChange;
  };

  useEffect(() => {
    if (priceId && methods.watch('output_type_id')) {
      handleChangeOutputType(methods.watch('output_type_id'));
    }
  }, [getAreaByOutputTypeOpts]);

  const handleChangeArea = async (value, opts) => {
    const cloneAreaOpts = structuredClone(areaOpts);
    let valueSet = opts;
    if (value) {
      let cloneAllArea = structuredClone(allArea);
      if (value[value.length - 1] == cloneAllArea.value) {
        valueSet = mapArrayRemoveKey(cloneAreaOpts, 'value', cloneAllArea.value);
      }
    }
    methods.setValue('areas', valueSet);
    methods.setValue('businesses', []);
    methods.setValue('stores', []);
    await handleGetBusiness(valueSet);
  };

  const handleChangeBusinesses = async (value, opts) => {
    const cloneBusinessOpts = structuredClone(businessOpts);
    let valueSet = opts;
    if (value) {
      let cloneAllBusiness = structuredClone(allBusiness);
      if (value[value.length - 1] == cloneAllBusiness.value) {
        valueSet = mapArrayRemoveKey(cloneBusinessOpts, 'value', cloneAllBusiness.value);
      }
    }
    methods.setValue('businesses', valueSet);
    methods.setValue('stores', []);
  };

  const handleGetBusiness = useCallback(async (selectedAreas = watchedAreas) => {
    try {
      if (selectedAreas && selectedAreas.length) {
        const areaIds = selectedAreas.map((_area) => _area.area_id).filter(Boolean);
        // Lấy danh sách cửa hàng theo khu vực đa chọn
        let cloneAllBusiness = structuredClone(allBusiness);
        const canUseMasterData = areaIds.every((areaId) => Array.isArray(getMasterValue(masterData.businesses_by_area, areaId)));
        const _business = canUseMasterData
          ? uniqueByKey(
            areaIds.flatMap((areaId) => getMasterValue(masterData.businesses_by_area, areaId) || []),
            'business_id',
          )
          : await getBusinessOfAreaOpts({ area_id: areaIds.join('|') });
        let nextBusinessOpts = mapDataOptions4SelectCustom(_business, 'business_id', 'business_name');
        if (nextBusinessOpts) {
          nextBusinessOpts.unshift(cloneAllBusiness);
        }
        setBusinessOpts(nextBusinessOpts);
        return nextBusinessOpts;
      } else {
        setBusinessOpts([]);
        return [];
      }
    } catch (error) {
      showToast.error(getErrorMessage(error));
      return [];
    }
  }, [masterData, watchedAreas]);

  useEffect(() => {
    handleGetBusiness(watchedAreas);
  }, [handleGetBusiness, watchedAreas]);

  const fetchStoreOpts = useCallback(
    (search = '') => {
      const params = {
        search,
        is_active: 1,
        itemsPerPage: 50,
      };

      if (selectedBusinessIds.length) {
        params.business_ids = selectedBusinessIds.join(',');
      }

      return getStoreOpts(params).then((body) => {
        return (body?.items || [])
          .filter((store) => {
            const businessId = store?.business_id ? String(store.business_id) : null;
            const matchBusiness = !selectedBusinessIds.length || selectedBusinessIds.includes(businessId);

            return matchBusiness;
          })
          .map((store) => ({
            label: store.store_name,
            value: store.store_id,
            ...store,
          }));
      });
    },
    [selectedBusinessIds],
  );

  const handleChangeBasePrices = async (_prices = 0) => {
    const grossPrice = Number(_prices || 0);
    methods.setValue('price_vat', grossPrice);
    methods.setValue('change_price', grossPrice);
    if (outputTypeDetail) {
      // Giá người dùng nhập luôn đã gồm VAT; chỉ tính ngược giá chưa VAT.
      const vatValue = outputTypeDetail?.vat_value * 1;
      const netPrice = vatValue ? Math.round(grossPrice / ((100 + vatValue) / 100)) : grossPrice;

      methods.setValue('base_price', netPrice);

      // lưu giá cho từng hình thức xuất nếu là làm giá nhiều hình thức
      // set danh sách duyệt theo hình thức xuất bán
      let list_output_type_submit = methods.watch('list_output_type_submit');

      if (methods.watch('is_many_outputs') && Object.values(list_output_type_submit).length) {
        Object.keys(list_output_type_submit).forEach((key) => {
          if (!list_output_type_submit[key].change_value) {
            list_output_type_submit[key].change_value = 0;
          }

          let vat_value = 0;
          if (list_output_type_submit[key].vat_value) {
            vat_value = list_output_type_submit[key].vat_value;
          }

          const outputGrossPrice = grossPrice + Number(list_output_type_submit[key].change_value || 0);
          const outputNetPrice = vat_value
            ? Math.round(outputGrossPrice / ((100 + vat_value) / 100))
            : outputGrossPrice;

          list_output_type_submit[key].price = outputGrossPrice;
          list_output_type_submit[key].change_price = outputGrossPrice;
          list_output_type_submit[key].base_price = outputNetPrice;
        });

        methods.setValue('list_output_type_submit', list_output_type_submit);

        const outputTypeRows = {
          ...(methods.watch('output_type_rows') || {}),
        };
        Object.keys(outputTypeRows).forEach((key) => {
          if (String(key) === String(methods.watch('output_type_id'))) {
            outputTypeRows[key] = {
              ...outputTypeRows[key],
              price: grossPrice,
              change_price: grossPrice,
              base_price: netPrice,
              change_value: 0,
              is_primary: true,
            };
          } else if (list_output_type_submit[key]) {
            outputTypeRows[key] = {
              ...outputTypeRows[key],
              ...list_output_type_submit[key],
            };
          }
        });
        methods.setValue('output_type_rows', outputTypeRows);
      }
    } else {
      methods.setValue('base_price', grossPrice);
    }
  };

  const handleChangeMarkupPercent = (value) => {
    setMarkupPercent(value);
    if (value === null || value === undefined || value === '') return;
    const percent = Number(value);
    if (!costReference.canCalculate || !Number.isFinite(percent)) return;

    const suggestedPrice = Math.round(costReference.price * (1 + percent / 100));
    handleChangeBasePrices(suggestedPrice);
  };

  const handleChangeMarkupAmount = (value) => {
    setMarkupAmount(value);
    if (value === null || value === undefined || value === '') return;
    const amount = normalizeMoney(value);
    if (!costReference.canCalculate || !Number.isFinite(amount)) return;

    handleChangeBasePrices(Math.round(costReference.price + amount));
  };

  const handleChangeMarkupMode = (value) => {
    setMarkupMode(value);

    if (value === MARKUP_MODE_AMOUNT && markupAmount !== null) {
      handleChangeMarkupAmount(markupAmount);
      return;
    }

    if (value === MARKUP_MODE_PERCENT && markupPercent !== null) {
      handleChangeMarkupPercent(markupPercent);
    }
  };

  const handelChangeManyOutput = async (checked, outputTypeIds = selectedOutputTypeIds) => {
    methods.setValue('is_many_outputs', checked);
    if (checked) {
      let list_output_type_submit = {};
      let output_type_rows = {};
      const selectedOutputTypes = getSelectedOutputTypeOptions(outputTypeOpts, outputTypeIds);
      const primaryOutputTypeId = methods.watch('output_type_id');

      for (let i = 0; i < selectedOutputTypes.length; i++) {
        let _items = selectedOutputTypes[i];

        let _outputTypeDetail = getMasterValue(masterData.output_type_details, _items?.value);
        if (_outputTypeDetail) {
          _outputTypeDetail = structuredClone(_outputTypeDetail);
        }
        if (!_outputTypeDetail) {
          _outputTypeDetail = await readDetialOuputType(_items?.value);
        }

        if (!_outputTypeDetail) continue;
        if (!_outputTypeDetail.change_value) {
          _outputTypeDetail.change_value = 0;
        }
        let vat_value = 0;
        if (_outputTypeDetail.vat_value) {
          vat_value = _outputTypeDetail.vat_value;
        }
        const uniformPriceVat = Number(methods.watch('price_vat') || 0);
        const uniformBasePrice = vat_value
          ? Math.round(uniformPriceVat / ((100 + vat_value) / 100))
          : uniformPriceVat;
        const isPrimary = String(_outputTypeDetail?.output_type_id) === String(primaryOutputTypeId);
        const outputGrossPrice = isPrimary
          ? uniformPriceVat
          : uniformPriceVat + Number(_outputTypeDetail.change_value || 0);
        const outputBasePrice = vat_value
          ? Math.round(outputGrossPrice / ((100 + vat_value) / 100))
          : outputGrossPrice;
        const outputTypeRow = {
          ..._items,
          ..._outputTypeDetail,
          is_primary: isPrimary,
          change_value: isPrimary ? 0 : _outputTypeDetail.change_value,
          price: outputGrossPrice,
          change_price: outputGrossPrice,
          base_price: outputBasePrice,
          reviews: autoApprove
            ? (_outputTypeDetail?.reviews || []).map((review) => ({ ...review, is_auto_reviewed: 1 }))
            : _outputTypeDetail?.reviews,
          ...(uniformOutputPrice
            ? {
                change_value: 0,
                price: uniformPriceVat,
                change_price: uniformPriceVat,
                base_price: uniformBasePrice,
              }
            : {}),
        };

        output_type_rows[_outputTypeDetail?.output_type_id] = outputTypeRow;
        if (!isPrimary) {
          list_output_type_submit[_outputTypeDetail?.output_type_id] = outputTypeRow;
        }
      }
      let cloneListOutputTypSubmit = structuredClone(output_type_rows);
      let arrOutputTypeList = Object.values(cloneListOutputTypSubmit) ?? [];
      let pushArray = [];
      let areaArray = [];
      let checkArrayToPush = [];
      if (arrOutputTypeList) {
        arrOutputTypeList?.map((val, index) => {
          if (val) {
            if (val?.area_id) {
              areaArray = val?.area_id ?? [];
              if (index === 0) {
                pushArray = areaArray;
                checkArrayToPush = getValueListToArr(areaArray, 'area_id');
              } else {
                if (checkArrayToPush) {
                  let checkPush = getValueListToArr(areaArray, 'area_id');
                  if (checkPush) {
                    checkArrayToPush = checkReduce(checkArrayToPush, checkPush);
                  }
                }
              }
            }
          }
        });
      }

      let clonePushArray = structuredClone(pushArray);
      if (checkArrayToPush && checkArrayToPush?.length) {
        checkArrayToPush.map((val, index) => {
          if (val) {
            clonePushArray = removeItemArr(val, clonePushArray);
          }
        });
      }
      let outputTypeId = structuredClone(methods.watch('output_type_id'));
      const dataAreaReturn = checkIsManyOutType(outputTypeId, areaOpts, clonePushArray);
      let resultDataArea = [];
      if (dataAreaReturn) {
        resultDataArea = dataAreaReturn;
      }

      setAreaOpts(resultDataArea);
      setAreaOptsManyOutType(resultDataArea);
      //Click Làm giá nhiều hình thức không xóa khu vực đã chọn
      // methods.setValue('areas', []);
      methods.setValue('list_output_type_submit', list_output_type_submit);
      methods.setValue('output_type_rows', output_type_rows);
      return resultDataArea;
    } else {
      methods.setValue('list_output_type_submit', {});
      methods.setValue('output_type_rows', {});
      return [];
    }
  };

  const handleChangeOutputTypeSelection = async (value) => {
    const {
      selectedOptions,
      outputTypeIds,
      primaryOutputTypeId,
      isManyOutputs: shouldUseManyOutputs,
    } = resolveOutputTypeSelection(value, outputTypeOpts, selectedOutputTypeIds);
    const currentOutputTypeId = methods.watch('output_type_id');

    methods.setValue('output_type_ids', selectedOptions, {
      shouldDirty: true,
      shouldValidate: true,
    });
    methods.setValue('is_many_outputs', shouldUseManyOutputs);

    if (!primaryOutputTypeId) {
      methods.setValue('output_type_id', null);
      methods.setValue('outputTypeDetail', null);
      methods.setValue('review_list', []);
      methods.setValue('list_output_type_submit', {});
      methods.setValue('output_type_rows', {});
      setOutputTypeDetail(undefined);
      return;
    }

    if (String(primaryOutputTypeId) !== String(currentOutputTypeId)) {
      await handleChangeOutputType(primaryOutputTypeId, { rebuildManyOutput: false });
    }

    await handelChangeManyOutput(shouldUseManyOutputs, outputTypeIds);
  };

  const handleToggleManyOutput = async (checked) => {
    if (selectedOutputTypeIds.length > 1) {
      methods.setValue('is_many_outputs', true);
      if (!checked) {
        showToast.warning('Đang chọn nhiều hình thức xuất nên chế độ làm giá nhiều hình thức được tự động bật.');
      }
      await handelChangeManyOutput(true, selectedOutputTypeIds);
      return;
    }

    if (checked) {
      methods.setValue('is_many_outputs', false);
      showToast.warning('Vui lòng chọn ít nhất 2 hình thức xuất.');
      return;
    }

    await handelChangeManyOutput(false, selectedOutputTypeIds);
  };

  useEffect(() => {
    if (!initializeAllScopes || initializedAllScopesRef.current || !outputTypeOpts.length) return;

    initializedAllScopesRef.current = true;
    const initializeDefaults = async () => {
      const selectedOutputTypeId = methods.watch('output_type_id');
      const selectedOutputType = outputTypeOpts.find(
        (option) => String(option?.value) === String(selectedOutputTypeId),
      );
      const primaryOutputTypeId = selectedOutputType?.value || outputTypeOpts[0]?.value;
      if (!primaryOutputTypeId) return;

      const allOutputTypeIds = outputTypeOpts.map((option) => option?.value).filter(Boolean);
      methods.setValue('output_type_ids', outputTypeOpts);
      await handleChangeOutputType(primaryOutputTypeId, { rebuildManyOutput: false });
      const commonAreas = await handelChangeManyOutput(true, allOutputTypeIds);
      const allAreas = (commonAreas || []).filter((item) => item?.value !== allArea.value);
      methods.setValue('areas', allAreas);

      const availableBusinesses = await handleGetBusiness(allAreas);
      const allBusinesses = (availableBusinesses || []).filter((item) => item?.value !== allBusiness.value);
      methods.setValue('businesses', allBusinesses);
      methods.setValue('stores', []);
    };

    initializeDefaults().catch((error) => {
      initializedAllScopesRef.current = false;
      showToast.error(getErrorMessage(error));
    });
    // Chỉ khởi tạo một lần sau khi danh mục hình thức xuất đã sẵn sàng.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initializeAllScopes, outputTypeOpts]);

  useEffect(() => {
    if (!outputTypeOpts.length || initializeAllScopes || selectedOutputTypeIds.length) return;

    const outputTypeId = methods.watch('output_type_id');
    const selectedOutputType = outputTypeOpts.find(
      (option) => String(option?.value) === String(outputTypeId),
    );
    if (selectedOutputType) {
      methods.setValue('output_type_ids', [selectedOutputType]);
    }
  }, [initializeAllScopes, outputTypeOpts, selectedOutputTypeIds.length]);

  const removeItemArr = (value, list) => {
    let cloneList = structuredClone(list);
    const index = cloneList.indexOf(value);
    if (index > -1) {
      // only splice array when item is found
      cloneList.splice(index, 1); // 2nd parameter means remove one item only
    }

    return cloneList;
  };

  const checkReduce = (listFirst, listSecond) => {
    let result = listFirst.filter((val) => listSecond.includes(val));
    return result;
  };

  const getValueListToArr = (list, field) => {
    let result = [];
    if (list && Array.isArray(list)) {
      list.map((val, index) => {
        if (val[field]) {
          result.push(val[field]);
        }
      });
    }
    return result;
  };

  const checkAreaInOutputType = (list = {}, field, value) => {
    if (list[field] == value) {
      return true;
    }
    return false;
  };

  return (
    <React.Fragment>
      <BWAccordion title={title} id='information' isRequired={true}>
        <div className='bw_price_form'>
          <div className='bw_price_scope_panel'>
            <div className='bw_price_panel_header'>
              <div>
                <p>Phạm vi áp dụng</p>
                <span>Hình thức xuất, thời gian, khu vực, chi nhánh và cửa hàng</span>
              </div>
              <div className='bw_price_scope_badges'>
                <span>{isAllAreasSelected ? 'Tất cả khu vực' : `${watchedAreas?.length || 0} khu vực`}</span>
                <span>{isAllBusinessesSelected ? 'Tất cả chi nhánh' : `${selectedBusinesses?.length || 0} chi nhánh`}</span>
                <span>{initializeAllScopes && !selectedStores.length ? 'Tất cả cửa hàng' : `${selectedStores?.length || 0} cửa hàng`}</span>
              </div>
            </div>

            <div className='bw_row bw_price_form_grid'>
              <FormItem label='Hình thức xuất' className='bw_col_4' disabled={disabled} isRequired={true}>
                <FormSelect
                  id='output_type_ids'
                  field='output_type_ids'
                  placeholder='Chọn một hoặc nhiều hình thức xuất'
                  list={outputTypeSelectOptions}
                  mode='multiple'
                  maxTagCount={2}
                  maxTagPlaceholder={(omittedValues) => (
                    <span className='bw_price_select_summary'>+{omittedValues.length} hình thức</span>
                  )}
                  onChange={handleChangeOutputTypeSelection}
                  validation={{
                    required: 'Hình thức xuất là bắt buộc',
                  }}
                />
              </FormItem>

              <FormItem label='Thời gian áp dụng' className='bw_col_4' disabled={disabled} isRequired={true}>
                {noExpiry ? (
                  <div className='bw_price_no_expiry_field'>
                    <FormDatePicker
                      field='start_date'
                      placeholder='Từ ngày'
                      format='DD/MM/YYYY'
                      allowClear={false}
                      validation={{ required: 'Ngày bắt đầu là bắt buộc' }}
                      disabledDate={disabledDate}
                    />
                    <span>Không hết hạn</span>
                  </div>
                ) : (
                  <FormRangePicker
                    fieldStart={'start_date'}
                    fieldEnd={'end_date'}
                    placeholder={['Từ ngày', 'Đến ngày']}
                    format={'DD/MM/YYYY'}
                    allowClear={true}
                    style={{ width: '100%' }}
                    validation={{
                      required: 'Thời gian áp dụng là bắt buộc',
                    }}
                    disabledDate={disabledDate}
                  />
                )}
              </FormItem>

              <FormItem label='Khu vực áp dụng' className='bw_col_4' disabled={disabled} isRequired={true}>
                <FormSelect
                  field='areas'
                  placeholder='Chọn khu vực'
                  list={areaOpts}
                  mode={'multiple'}
                  maxTagCount={isAllAreasSelected ? 0 : 2}
                  maxTagPlaceholder={(omittedValues) => (
                    <span className='bw_price_select_summary'>
                      {isAllAreasSelected ? 'Tất cả khu vực' : `+${omittedValues.length} khu vực`}
                    </span>
                  )}
                  onChange={handleChangeArea}
                  validation={{
                    required: 'Khu vực áp dụng là bắt buộc',
                  }}
                />
              </FormItem>

              <FormItem
                label='Chi nhánh'
                className='bw_col_6 bw_price_business_select'
                disabled={disabled ? disabled : !methods.watch('areas')?.length}
                isRequired={true}>
                <FormSelect
                  id='businesses'
                  field='businesses'
                  placeholder='Chọn chi nhánh áp dụng'
                  list={businessOpts}
                  onChange={handleChangeBusinesses}
                  mode={'multiple'}
                  maxTagCount={isAllBusinessesSelected ? 0 : 2}
                  maxTagPlaceholder={(omittedValues) => (
                    <span className='bw_price_select_summary'>
                      {isAllBusinessesSelected ? 'Tất cả chi nhánh' : `+${omittedValues.length} chi nhánh`}
                    </span>
                  )}
                  validation={{
                    required: 'Chi nhánh làm giá là bắt buộc',
                  }}
                />
              </FormItem>

              <FormItem
                label='Cửa hàng áp dụng'
                className='bw_col_6 bw_price_business_select'
                disabled={disabled ? disabled : !selectedBusinesses.length}>
                <FormDebouneSelect
                  id='stores'
                  field='stores'
                  placeholder='Tất cả cửa hàng trong chi nhánh đã chọn'
                  fetchOptions={fetchStoreOpts}
                  mode='multiple'
                  allowClear={true}
                  disabled={disabled ? disabled : !selectedBusinesses.length}
                  isLoadingFirst={Boolean(selectedBusinesses.length)}
                  maxTagCount={2}
                  maxTagPlaceholder={(omittedValues) => (
                    <span className='bw_price_select_summary'>+{omittedValues.length} cửa hàng</span>
                  )}
                />
              </FormItem>
            </div>
          </div>

          {paramHidden !== checkProductType['3'] ? (
            <div className='bw_price_value_panel'>
              <div className='bw_price_panel_header'>
                <div>
                  <p>Giá bán</p>
                  <span>Nhập giá cuối cùng đã gồm VAT; hệ thống tự tính ngược giá chưa VAT</span>
                </div>
                <span className='bw_price_vat_badge'>VAT {vatValue || 0}%</span>
              </div>

              <div className='bw_price_cost_tools'>
                <div className={`bw_price_cost_card ${costReference.canCalculate ? '' : 'bw_price_cost_card_disabled'}`}>
                  <span>{costReferenceTitle}</span>
                  <strong>{costReference.canCalculate ? `${vietnameseNumbers ? formatWarrantyNumber(costReference.price, 4) : costReference.label} đ` : costReference.label}</strong>
                  <small>{costReference.source || costReferenceSourceFallback}</small>
                </div>
                <div className='bw_price_markup_field'>
                  <div className='bw_price_markup_header'>
                    <span>{enableMarkupAmount ? 'Mức tăng giá' : 'Tỷ lệ tăng giá'}</span>
                    {enableMarkupAmount ? (
                      <Segmented
                        size='small'
                        value={markupMode}
                        disabled={disabled || !costReference.canCalculate}
                        options={[
                          { label: '%', value: MARKUP_MODE_PERCENT },
                          { label: 'đ', value: MARKUP_MODE_AMOUNT },
                        ]}
                        onChange={handleChangeMarkupMode}
                      />
                    ) : null}
                  </div>
                  {markupMode === MARKUP_MODE_AMOUNT && enableMarkupAmount ? (
                    <InputNumber
                      min={0}
                      value={markupAmount}
                      disabled={disabled || !costReference.canCalculate}
                      onChange={handleChangeMarkupAmount}
                      placeholder='Nhập số tiền'
                      addonAfter='đ'
                      formatter={moneyFormatter}
                      parser={moneyParser}
                      controls={false}
                    />
                  ) : (
                    <InputNumber
                      min={0}
                      max={9999}
                      value={markupPercent}
                      disabled={disabled || !costReference.canCalculate}
                      onChange={handleChangeMarkupPercent}
                      placeholder='Nhập %'
                      addonAfter='%'
                      controls={false}
                    />
                  )}
                </div>
                <div className='bw_price_cost_card'>
                  <span>Giá bán đề xuất</span>
                  <strong>{displayMoney(priceVat)} VNĐ</strong>
                  <small>Tự điền vào giá bán có VAT</small>
                </div>
              </div>

              <div className='bw_row bw_price_form_grid'>
                <FormItem label={priceVatLabel} className='bw_col_6 bw_price_input_main' disabled={disabled} isRequired={true}>
                  <FormNumber
                    field='price_vat'
                    placeholder='Nhập giá cuối cùng đã gồm VAT'
                    bordered={false}
                    value={priceVat}
                    formatter={moneyFormatter}
                    parser={moneyParser}
                    onChange={(value) => handleChangeBasePrices(value)}
                  // validation={{
                  //   required: paramHidden !== checkProductType['3'],
                  //   min: {
                  //     value: 0,
                  //     message: 'Giá bán phải lớn hơn 0',
                  //   },
                  // }}
                  />
                </FormItem>

                <FormItem label='Giá bán chưa VAT (đ)' className='bw_col_6 bw_price_input_readonly' disabled={true}>
                  <FormNumber
                    field='base_price'
                    placeholder='Giá bán chưa VAT'
                    bordered={false}
                    value={basePrice}
                    formatter={moneyFormatter}
                    parser={moneyParser}
                  // validation={{
                  //   min: {
                  //     value: 0,
                  //     message: 'Giá bán có VAT phải lớn hơn 0',
                  //   },
                  // }}
                  />
                </FormItem>
              </div>

              <div className='bw_price_summary'>
                <div>
                  <span>Giá có VAT</span>
                  <strong>{displayMoney(priceVat)} VNĐ</strong>
                </div>
                <div>
                  <span>Giá chưa VAT</span>
                  <strong>{displayMoney(basePrice)} VNĐ</strong>
                </div>
                <div>
                  <span>Thuế VAT</span>
                  <strong>{displayMoney(Number(priceVat || 0) - Number(basePrice || 0))} VNĐ</strong>
                </div>
              </div>
            </div>
          ) : null}

          <div className='bw_price_option_panel'>
            <label className='bw_checkbox bw_price_option_item'>
              <FormInput disabled={disabled} type='checkbox' field='is_active' value={methods.watch('is_active')} />
              <span />
              Kích hoạt
            </label>
            {!disabled && !priceId && !hideManyOutput ? (
              <label className='bw_checkbox bw_price_option_item'>
                <FormInput
                  disabled={disabled}
                  type='checkbox'
                  field='is_many_outputs'
                  onChange={({ target: { checked } }) => {
                    handleToggleManyOutput(checked);
                  }}
                />
                <span />
                Làm giá nhiều hình thức xuất
              </label>
            ) : null}
          </div>
        </div>
        {isManyOutputs ? (
          <div className='bw_price_many_output_panel'>
            <div className='bw_price_many_output_note'>
              {uniformOutputPrice
                ? 'Các hình thức xuất đã chọn dùng chung một giá combo và được tự động duyệt.'
                : 'Chỉ tạo giá cho các hình thức xuất đã chọn; mỗi hình thức sử dụng quy trình duyệt riêng.'}
            </div>
            <OutputTypeTable disabled={disabled} uniformPrice={uniformOutputPrice} />
          </div>
        ) : null}
      </BWAccordion>
    </React.Fragment>
  );
};

export default PricesInfor;
